import React, { useState, useRef } from "react";
import {
  ADD_TYPE_IMAGE,
  DEL_TYPE_IMAGE,
  UPDATE_TYPE_IMAGE,
} from "../../../store/constants/serviceEndpoint";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import * as enums from "../../../common/enum";
import { Button } from "primereact/button";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Messages } from "primereact/messages";
import _ from "lodash";

const initData = {
  Id: 0,
  Name: "",
  Description: "",
  Order: 0,
  EventId: 0,
};

export default function ImageEvent({ eventId, data, onReloadData }) {
  const refMessage = useRef(null);

  //   const [isEdit, setIsEdit] = useState(false);
  const [item, setItem] = useState(initData);
  const [loading, setLoading] = useState(false);

  const [visible, setVisible] = useState(false);
  //   console.log(data);

  const capitalizeFirstLetter = (string) => {
    return string[0].toUpperCase() + string.slice(1);
  };

  const updateItem = (e, item) => {
    e.preventDefault();
    let obj = {};
    for (let key in item) {
      obj[capitalizeFirstLetter(key)] = item[key];
    }
    setItem(obj);
    setVisible(true);
  };

  const checkData = (obj) => {
    for (var field in obj) {
      if (
        obj[field] === undefined ||
        obj[field] === null ||
        obj[field] === "" ||
        obj[field] === 0
      ) {
        switch (field) {
          case "Name":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng nhập tên hình !",
            });
            break;
          case "Description":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng nhập mô tả về hình!",
            });
            break;
          default:
            break;
        }
        return false;
      }
    }
    return true;
  };

  const onAddData = async (e) => {
    e.preventDefault();

    let objAdd = {};
    objAdd.Name = item.Name;
    objAdd.Description = item.Description;
    const check = checkData(objAdd);
    if (check) {
      objAdd.Order = item.Order;
      objAdd.EventId = eventId;
      setLoading(true);
      await axiosWithHeaders("post", ADD_TYPE_IMAGE, objAdd)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              onReloadData(eventId);
              Swal.fire(
                "Thông báo",
                "Thêm cài đặt hình thành công !",
                "success"
              );
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => {
          Swal.fire("Lỗi", err.toString(), "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteItem = (e, Id) => {
    e.preventDefault();

    Swal.fire({
      title: "Thông báo",
      text: "Bạn có muốn xóa cài đặt hình này không ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý!",
      cancelButtonText: "Trở về",
    }).then((result) => {
      if (result.value) {
        axiosWithHeaders("post", DEL_TYPE_IMAGE, { Id })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.status === enums.RESPONSE_OK
            ) {
              const { status, message } = response.data;
              if (status === enums.RESPONSE_OK) {
                onReloadData(eventId);
                Swal.fire(
                  "Thông báo",
                  "Xóa cài đặt hình thành công !",
                  "success"
                );
              } else {
                Swal.fire("Lỗi", message, "error");
              }
            }
          })
          .catch((err) => {
            Swal.fire("Lỗi", err.toString(), "error");
          });
      }
    });
  };

  const onUpdateData = async (e) => {
    e.preventDefault();

    let objUpdate = {};
    objUpdate.Name = item.Name;
    objUpdate.Description = item.Description;
    const check = checkData(objUpdate);
    if (check) {
      objUpdate.Order = item.Order;
      objUpdate.EventId = eventId;
      objUpdate.id = item.Id;

      setLoading(true);
      await axiosWithHeaders("post", UPDATE_TYPE_IMAGE, objUpdate)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              onReloadData(eventId);
              Swal.fire(
                "Thông báo",
                "Cập nhật cài đặt hình thành công !",
                "success"
              );
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => {
          Swal.fire("Lỗi", err.toString(), "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const cellTemplate = (row, column) => {
    const field = column.field;
    switch (field) {
      default:
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <Button
              icon="pi pi-pencil"
              className="p-button-success p-button-raised"
              style={{ marginRight: 7, width: 35 }}
              onClick={(e) => updateItem(e, row)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-raised"
              style={{ width: 35 }}
              onClick={(e) => deleteItem(e, row.id)}
            />
          </div>
        );
    }
  };

  const footer = (
    <>
      {item && item.Id ? (
        <Button
          label="Cập nhật"
          icon="pi pi-check"
          onClick={onUpdateData}
          className="p-button-raised p-button-info"
          loading={loading}
        />
      ) : (
        <Button
          label="Xác nhận"
          icon="pi pi-check"
          onClick={onAddData}
          className="p-button-raised p-button-success"
          loading={loading}
        />
      )}

      <Button
        label="Hủy"
        className="p-button-raised p-button-secondary"
        icon="pi pi-times"
        onClick={() => {
          setVisible(false);
          setItem(initData);
        }}
        loading={loading}
      />
    </>
  );

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-between`}
        >
          <div style={{ minWidth: 100 }}></div>
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT HOẠT ĐỘNG
          </div>
          <div>
            <Button
              label="THÊM"
              icon="pi pi-plus"
              className="p-button-raised p-button-secondary"
              onClick={() => {
                setVisible(true);
                setItem(initData);
              }}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <DataTable
            value={data}
            emptyMessage="Hoạt động này chưa tạo hình nào...."
          >
            <Column field="name" header="Tên hình" />
            <Column field="description" header="Mô tả" />
            <Column
              field="order"
              header="Thứ tự"
              style={{ width: 60 }}
              className={"p-col-fixed"}
            />
            <Column
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
          </DataTable>
        </div>
      </div>

      <Dialog
        header={item && item.Id ? "Cập nhật hình" : "Thêm hình"}
        footer={footer}
        visible={visible}
        style={{ width: "600px" }}
        modal={true}
        onHide={() => {
          setVisible(false);
          setItem(initData);
        }}
      >
        <div className="row mt-2">
          <div className="col-md-12">
            <Messages ref={refMessage} style={{ width: "100%" }} />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="txtImageName">Tên hình</label>
          </div>
          <div className="col-md-9">
            <InputText
              id="txtImageName"
              placeholder="Nhập tên hình...."
              style={{ width: "100%" }}
              onChange={(e) => setItem({ ...item, Name: e.target.value })}
              value={item && item.Name ? item.Name : ""}
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-start text-right">
            <label htmlFor="txtImageDescription">Mô tả</label>
          </div>
          <div className="col-md-9">
            <InputTextarea
              id="txtImageDescription"
              rows={5}
              style={{ width: "100%" }}
              value={item && item.Description ? item.Description : ""}
              onChange={(e) =>
                setItem({ ...item, Description: e.target.value })
              }
              placeholder="Nhập mô tả về hình..."
            />
          </div>
        </div>
        <div className="row mt-2" style={{ minHeight: 35 }}>
          <div className="col-md-3 align-self-start text-right">
            <label htmlFor="txtImageOrder">Thứ tự hiển thị</label>
          </div>
          <div className="col-md-2">
            <InputText
              id="txtImageOrder"
              placeholder="0"
              style={{ width: "100%", color: "red", textAlign: "right" }}
              //   onChange={(e) => this.setState({ Order: e.target.value })}
              value={item && item.Order ? item.Order : 0}
              onChange={(e) => setItem({ ...item, Order: e.target.value })}
            />
          </div>
        </div>
        {/* <div className="p-grid">
          <Messages
            ref={(el) => (this.messages = el)}
            style={{ width: "100%" }}
          ></Messages>
        </div>
        <div className="p-grid" style={{ marginTop: 5 }}>
          <div
            className="p-col-3"
            style={{ paddingBottom: 0, textAlign: "right" }}
          >
            <label></label>
          </div>
          <div className="p-col-6" style={{ paddingTop: 0 }}>
            
          </div>
        </div>
        <div className="p-grid" style={{ marginTop: 5 }}>
          <div
            className="p-col-3"
            style={{ paddingBottom: 0, textAlign: "right" }}
          >
            <label>Mô tả </label>
          </div>
          <div className="p-col-9" style={{ paddingTop: 0 }}>
            <InputTextarea
              rows={5}
              style={{ width: "100%" }}
              value={this.state.Description}
              onChange={(e) => this.setState({ Description: e.target.value })}
              placeholder="Nhập mô tả về hình..."
            />
          </div>
        </div>
        <div className="p-grid" style={{ marginTop: 5 }}>
          <div
            className="p-col-3"
            style={{ paddingBottom: 0, textAlign: "right" }}
          >
            <label>Thứ tự hiển thị </label>
          </div>
          <div className="p-col-1" style={{ paddingTop: 0 }}>
            <InputText
              placeholder="0"
              style={{ width: "100%", color: "red", textAlign: "right" }}
              onChange={(e) => this.setState({ Order: e.target.value })}
              value={this.state.Order}
            />
          </div>
        </div> */}
      </Dialog>
    </>
  );
}
